/**
 * DashboardSkeleton Component
 *
 * Loading skeleton for the dashboard page during initial data fetch.
 * Provides visual placeholder matching the dashboard layout structure.
 */

import {
  SkeletonPage,
  SkeletonBodyText,
  SkeletonDisplayText,
  Layout,
  Card,
  BlockStack,
  InlineStack,
  Box,
} from '@shopify/polaris';

/**
 * Skeleton loading state for the dashboard
 * Displays placeholder content while data is being fetched
 */
export function DashboardSkeleton() {
  return (
    <SkeletonPage title="Dashboard" primaryAction>
      <Layout>
        <Layout.Section>
          <BlockStack gap="500">
            {/* Stats row skeleton */}
            <Card>
              <BlockStack gap="400">
                <InlineStack gap="400" wrap={false}>
                  {[1, 2, 3, 4].map((i) => (
                    <Box key={i} width="25%">
                      <BlockStack gap="200">
                        <SkeletonDisplayText size="small" />
                        <SkeletonBodyText lines={1} />
                      </BlockStack>
                    </Box>
                  ))}
                </InlineStack>
              </BlockStack>
            </Card>

            {/* Chart skeleton */}
            <Card>
              <BlockStack gap="400">
                <SkeletonDisplayText size="small" />
                <Box minHeight="200px">
                  <SkeletonBodyText lines={8} />
                </Box>
              </BlockStack>
            </Card>

            {/* Table skeleton */}
            <Card>
              <BlockStack gap="400">
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={6} />
              </BlockStack>
            </Card>
          </BlockStack>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
}
